import React, { useState, useRef } from "react";
import ReactDOM from "react-dom";
import styles from "./tooltip-bubble.module.scss";

const TooltipBubble = ({ content, children, disabled = false }) => {
  const [visible, setVisible] = useState(false);
  const [position, setPosition] = useState({ top: 0, left: 0 });
  const wrapperRef = useRef(null);

  const handleMouseEnter = () => {
    if (!disabled && wrapperRef.current) {
      const rect = wrapperRef.current.getBoundingClientRect();
      setPosition({
        top: rect.bottom + window.scrollY + 8,
        left: rect.left + window.scrollX,
      });
      setVisible(true);
    }
  };

  const handleMouseLeave = () => {
    if (!disabled) setVisible(false);
  };

  const tooltip = visible && !disabled && (
    <div
      className={styles.tooltipContainer}
      style={{
        top: position.top,
        left: position.left,
        position: "absolute",
      }}
    >
      <span className={styles.tooltipArrow} />
      <div className={styles.tooltipBubble}>{content}</div>
    </div>
  );

  return (
    <>
      <div
        ref={wrapperRef}
        className={styles.tooltipWrapper}
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
      >
        {children}
      </div>

      {ReactDOM.createPortal(tooltip, document.body)}
    </>
  );
};

export default TooltipBubble;
